import { memo } from "react";
import "./product-card-skeleton.css";

function ProductCardSkeleton() {
  return (
    <div className="product-skeleton-col" aria-hidden="true">
      <div className="skeleton-image-container" />
      <div className="skeleton-text-container"><span /><span /></div>
      <div className="skeleton-button" />
    </div>
  );
}
export default memo(ProductCardSkeleton);
